(function () {
  var WIDGET_KEY = '__mldReelsWidgetState';
  /* Fix1: con prefers-reduced-motion los videos NO arrancan solos (el usuario toca ▶). */
  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* ── Íconos SVG (consistentes en todo dispositivo, a diferencia de los emoji) ── */
  var ICON_PLAY  = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.14v13.72a1 1 0 0 0 1.53.85l10.79-6.86a1 1 0 0 0 0-1.7L9.53 4.29A1 1 0 0 0 8 5.14z"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6.5" y="5" width="4" height="14" rx="1.4"/><rect x="13.5" y="5" width="4" height="14" rx="1.4"/></svg>';
  var ICON_SOUND_ON  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9v6h3.5L13 20V4L7.5 9H4z" fill="currentColor" stroke="none"/><path d="M16.5 8.5a5 5 0 0 1 0 7"/><path d="M19 6a9 9 0 0 1 0 12"/></svg>';
  var ICON_SOUND_OFF = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9v6h3.5L13 20V4L7.5 9H4z" fill="currentColor" stroke="none"/><path d="M17 9.5l4 5M21 9.5l-4 5"/></svg>';

  /* ── Helpers ── */

  function parseConfigFromNode(container) {
    var raw = container.getAttribute('data-mld-reels-config');
    if (!raw) return {};
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }

  function getThumbnailUrl(videoId) {
    return 'https://img.youtube.com/vi/' + encodeURIComponent(videoId) + '/hqdefault.jpg';
  }

  function sendYTCommand(iframe, func) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify({
      event: 'command',
      func:  func,
      args:  func === 'seekTo' ? [0, true] : []
    }), '*');
  }

  function sendYTInit(iframe) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify({ event: 'listening' }), '*');
  }

  function isYouTubeMessage(event) {
    return /^https:\/\/(www\.)?youtube(-nocookie)?\.com$/.test(event.origin);
  }

  function parseYouTubeMessage(data) {
    if (!data) return null;
    if (typeof data === 'string') { try { return JSON.parse(data); } catch (e) { return null; } }
    return typeof data === 'object' ? data : null;
  }

  /* ── DOM builders ── */

  function buildPreview(video) {
    var preview = document.createElement('div');
    preview.className = 'mld-reels-preview';
    preview.setAttribute('aria-hidden', 'true');

    var img = document.createElement('img');
    img.className  = 'mld-reels-preview__image';
    img.src        = getThumbnailUrl(video.youtubeId);
    img.alt        = '';
    img.loading    = 'lazy';

    var badge = document.createElement('span');
    badge.className   = 'mld-reels-preview__badge';
    badge.textContent = '▶';

    preview.appendChild(img);
    preview.appendChild(badge);
    return preview;
  }

  function buildIframe(videoId, muted) {
    var iframe = document.createElement('iframe');
    iframe.allow           = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.loading         = 'eager';
    iframe.tabIndex        = -1;
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) +
      '?autoplay=1&mute=' + (muted ? '1' : '0') +
      '&playsinline=1&loop=1&playlist=' + encodeURIComponent(videoId) +
      '&enablejsapi=1&controls=0&fs=0&iv_load_policy=3&rel=0&modestbranding=1&disablekb=1' +
      '&origin=' + encodeURIComponent(window.location.origin);
    iframe.title = 'Video de Moldarte';
    return iframe;
  }

  function createControlButton(options) {
    var button = document.createElement('button');
    button.type      = 'button';
    button.className = 'mld-reels-control-button ' + options.className;
    button.setAttribute(options.dataAttribute, '');
    button.setAttribute('aria-label', options.label);
    if (options.pressed != null) button.setAttribute('aria-pressed', String(options.pressed));
    button.innerHTML =
      '<span class="mld-reels-control-button__icon ' + options.iconClass + '" aria-hidden="true">' + options.icon + '</span>' +
      '<span class="mld-reels-control-button__text">' + (options.text || '') + '</span>';
    return button;
  }

  function createSlide(video, index) {
    var slide = document.createElement('article');
    slide.className = 'mld-reels-slide';
    slide.setAttribute('data-index', index);

    var frame = document.createElement('div');
    frame.className = 'mld-reels-video-frame';
    frame.setAttribute('data-frame', '');
    frame.setAttribute('data-video-id', video.youtubeId || '');

    if (video.videoUrl) {
      /* Video hosteado (Shopify): <video> nativo. Persiste en la slide (muestra
         el primer frame cuando está pausado); se reproduce al activarse. */
      var v = document.createElement('video');
      v.className = 'mld-reels-video-el';
      /* Sin portada: agregamos #t=0.1 para que iOS pinte el primer frame en
         pausa (si no, el <video> se ve transparente en mobile). */
      v.src = video.poster || video.videoUrl.indexOf('#') !== -1
        ? video.videoUrl
        : video.videoUrl + '#t=0.1';
      if (video.poster) v.poster = video.poster;
      v.muted = true; v.loop = true; v.tabIndex = -1;
      v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      v.preload = 'metadata';
      /* Si no hay portada, forzar el primer frame con un seek (iOS no lo pinta
         solo y el <video> se ve transparente en pausa). El seek no requiere gesto. */
      if (!video.poster) {
        var paintPoster = function () { try { if (v.currentTime < 0.05) v.currentTime = 0.1; } catch (e) {} };
        if (v.readyState >= 1) paintPoster();
        else v.addEventListener('loadedmetadata', paintPoster, { once: true });
      }
      frame.appendChild(v);
    } else {
      /* Preview (thumbnail de YouTube) mientras el iframe carga / slide inactiva */
      frame.appendChild(buildPreview(video));
    }

    /* Title overlay — shown on inactive slides */
    var captionInside = document.createElement('p');
    captionInside.className   = 'mld-reels-caption mld-reels-caption--inside';
    captionInside.textContent = video.title || '';
    frame.appendChild(captionInside);

    /* Controls — shown only on active slide */
    var controls = document.createElement('div');
    controls.className = 'mld-reels-video-controls';

    controls.appendChild(createControlButton({
      className:     'mld-reels-play-toggle',
      dataAttribute: 'data-mld-reels-play-toggle',
      label:         'Reproducir video',
      pressed:       false,
      iconClass:     'mld-reels-play-toggle__icon',
      icon:          ICON_PLAY,
      text:          ''
    }));

    controls.appendChild(createControlButton({
      className:     'mld-reels-audio-toggle',
      dataAttribute: 'data-mld-reels-audio-toggle',
      label:         'Activar sonido',
      pressed:       false,
      iconClass:     'mld-reels-audio-toggle__icon',
      icon:          ICON_SOUND_OFF,
      text:          ''
    }));

    frame.appendChild(controls);

    /* Spinner de carga (visible mientras el video del slide activo está cargando/buffering) */
    var loader = document.createElement('span');
    loader.className = 'mld-reels-loader';
    loader.setAttribute('aria-hidden', 'true');
    frame.appendChild(loader);

    /* Barra de progreso del video (estilo stories) — sólo visible en slide activa */
    var progress = document.createElement('span');
    progress.className = 'mld-reels-progress';
    var progressFill = document.createElement('span');
    progressFill.className = 'mld-reels-progress__fill';
    progressFill.setAttribute('data-mld-reels-progress', '');
    progress.appendChild(progressFill);
    frame.appendChild(progress);

    slide.appendChild(frame);

    /* Solapa below video — shown on active slide */
    var captionOutside = document.createElement('p');
    captionOutside.className   = 'mld-reels-caption mld-reels-caption--outside';
    captionOutside.textContent = video.title || '';
    slide.appendChild(captionOutside);

    return slide;
  }

  /* ── Iframe lifecycle ── */

  function getFrame(slide)   { return slide ? slide.querySelector('[data-frame]')                    : null; }
  function getIframe(slide)  { return slide ? slide.querySelector('iframe')                          : null; }
  function getVideoEl(slide) { return slide ? slide.querySelector('.mld-reels-video-el')             : null; }
  function setSlideProgress(slide, ratio) {
    var f = slide ? slide.querySelector('[data-mld-reels-progress]') : null;
    if (f) f.style.transform = 'scaleX(' + Math.max(0, Math.min(1, ratio || 0)) + ')';
  }
  function getPlayToggle(s)  { return s     ? s.querySelector('[data-mld-reels-play-toggle]')        : null; }
  function getAudioToggle(s) { return s     ? s.querySelector('[data-mld-reels-audio-toggle]')       : null; }

  function loadIframe(frame, video, muted) {
    var old = frame.querySelector('iframe');
    if (old) frame.removeChild(old);

    /* Remove preview — iframe covers the frame; preview was just the loading state */
    var preview = frame.querySelector('.mld-reels-preview');
    if (preview) frame.removeChild(preview);

    /* Insert iframe before the inside caption so stacking order is correct */
    var captionInside = frame.querySelector('.mld-reels-caption--inside');
    var iframe = buildIframe(video.youtubeId, muted);
    frame.insertBefore(iframe, captionInside || null);
    return iframe;
  }

  function unloadIframe(frame, video) {
    var iframe = frame.querySelector('iframe');
    if (iframe) {
      sendYTCommand(iframe, 'mute');
      sendYTCommand(iframe, 'pauseVideo');
      frame.removeChild(iframe);
    }
    /* Restore preview thumbnail */
    if (!frame.querySelector('.mld-reels-preview')) {
      var captionInside = frame.querySelector('.mld-reels-caption--inside');
      frame.insertBefore(buildPreview(video), captionInside || null);
    }
  }

  /* ── Controls ── */

  function lockSlideInteractivity(state, activeIndex) {
    state.slides.forEach(function (slide, index) {
      var isActive = index === activeIndex;
      slide.classList.toggle('is-active',   isActive);
      slide.classList.toggle('is-inactive', !isActive);
      /* Fix1: las inactivas quedan inert (fuera del tab y del lector); el clic para
         activarlas lo resuelve el track (ver bindEvents), porque inert no recibe clics. */
      if (isActive) { slide.removeAttribute('inert'); slide.removeAttribute('aria-hidden'); }
      else { slide.setAttribute('inert', ''); slide.setAttribute('aria-hidden', 'true'); }
    });
  }

  function updateVideoControls(state) {
    state.slides.forEach(function (slide, index) {
      var playBtn  = getPlayToggle(slide);
      var audioBtn = getAudioToggle(slide);
      var isActive  = index === state.activeIndex;
      /* isPlaying is confirmed by YouTube; controls reflect reality */
      var isPlaying = isActive && state.isPlaying;

      [playBtn, audioBtn].forEach(function (btn) {
        if (!btn) return;
        btn.classList.toggle('is-hidden', !isActive);
        btn.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      if (playBtn) {
        playBtn.setAttribute('aria-label',   isPlaying ? 'Pausar video'  : 'Reproducir video');
        playBtn.setAttribute('aria-pressed', String(isPlaying));
        playBtn.querySelector('.mld-reels-play-toggle__icon').innerHTML = isPlaying ? ICON_PAUSE : ICON_PLAY;
      }

      if (audioBtn) {
        var soundOn = isActive && !state.isMuted;
        audioBtn.setAttribute('aria-label',   soundOn ? 'Silenciar'     : 'Activar sonido');
        audioBtn.setAttribute('aria-pressed', String(soundOn));
        audioBtn.querySelector('.mld-reels-audio-toggle__icon').innerHTML = soundOn ? ICON_SOUND_ON : ICON_SOUND_OFF;
      }
    });
  }

  function togglePlayPause(state) {
    /* Nativo: control directo e inmediato (sin timers), para un comportamiento consistente. */
    var v = getVideoEl(state.slides[state.activeIndex]);
    if (v) {
      if (v.paused) {
        state.userPaused = false;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else {
        state.userPaused = true;
        v.pause();
      }
      state.isPlaying = !v.paused;
      updateVideoControls(state);
      return;
    }
    /* YouTube: control asincrónico vía sync. Con reduced motion el iframe no se
       cargó al activar la slide: se carga recién con el gesto del usuario. */
    var ytSlide = state.slides[state.activeIndex];
    if (!getIframe(ytSlide) && getFrame(ytSlide)) {
      state.userPaused = false;
      state.isPlaying = true;
      var lazyIframe = loadIframe(getFrame(ytSlide), state.videos[state.activeIndex], state.isMuted);
      lazyIframe.addEventListener('load', function () { sendYTInit(lazyIframe); schedulePlayerSync(state); });
      updateVideoControls(state);
      return;
    }
    state.userPaused = state.isPlaying;
    state.isPlaying = !state.isPlaying;
    updateVideoControls(state);
    schedulePlayerSync(state);
  }

  function toggleAudio(state) {
    state.isMuted = !state.isMuted;
    var v = getVideoEl(state.slides[state.activeIndex]);
    if (v) {
      v.muted = state.isMuted;
      /* Al activar sonido, asegurar que esté reproduciendo (permitido tras el gesto). */
      if (!state.isMuted && !state.userPaused && v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function (err) {
          if (err && err.name === 'NotAllowedError') { state.isMuted = true; v.muted = true; updateVideoControls(state); }
        });
      }
      updateVideoControls(state);
      return;
    }
    updateVideoControls(state);
    schedulePlayerSync(state);
  }

  /* ── Player sync ── */

  function cancelTimers(arr) {
    (arr || []).forEach(function (id) { window.clearTimeout(id); });
  }

  function schedulePlayerSync(state) {
    cancelTimers(state.syncTimers);
    state.syncTimers = [0, 200, 520].map(function (delay) {
      return window.setTimeout(function () { syncActivePlayer(state); }, delay);
    });
  }

  function syncActivePlayer(state) {
    cancelTimers(state.audioTimers);
    state.audioTimers = [];

    var activeSlide = state.slides[state.activeIndex];

    /* Video nativo (Shopify): control directo, sin postMessage. */
    var vEl = getVideoEl(activeSlide);
    if (vEl) {
      /* Estado de audio SIEMPRE reflejado (idempotente). */
      vEl.muted = state.isMuted;
      if (!state.userPaused) {
        if (vEl.readyState < 3) activeSlide.classList.add('is-loading');
        if (state.pendingSeek) { try { vEl.currentTime = 0; } catch (e) {} state.pendingSeek = false; }
        /* Sólo llamar play() si realmente está pausado: llamarlo mientras ya
           reproduce genera un rechazo (AbortError) que NO debe mutear nada. */
        if (vEl.paused) {
          var pr = vEl.play();
          if (pr && pr.catch) pr.catch(function (err) {
            /* Sólo el bloqueo real de autoplay (sin gesto) justifica mutear.
               Los AbortError por play() interrumpido se ignoran → el audio no se cae. */
            if (err && err.name === 'NotAllowedError' && !state.isMuted) {
              state.isMuted = true; vEl.muted = true; updateVideoControls(state);
              var p2 = vEl.play(); if (p2 && p2.catch) p2.catch(function () {});
            }
          });
        }
      } else {
        vEl.pause();
      }
      return;
    }

    var iframe = getIframe(activeSlide);
    if (!iframe) return;

    sendYTInit(iframe);

    /* Always try to play unless user explicitly paused */
    if (!state.userPaused) {
      sendYTCommand(iframe, 'mute');
      if (state.pendingSeek) {
        sendYTCommand(iframe, 'seekTo');
        state.pendingSeek = false;
      }
      sendYTCommand(iframe, 'playVideo');

      if (!state.isMuted) {
        state.audioTimers = [220, 580].map(function (delay) {
          return window.setTimeout(function () {
            var cur = getIframe(state.slides[state.activeIndex]);
            if (cur && !state.userPaused && !state.isMuted) sendYTCommand(cur, 'unMute');
          }, delay);
        });
      }
    } else {
      sendYTCommand(iframe, state.isMuted ? 'mute' : 'unMute');
      sendYTCommand(iframe, 'pauseVideo');
    }
  }

  /* YouTube postMessage handler — ground truth for controls sync */
  function handlePlayerStateMessage(state, event) {
    if (!isYouTubeMessage(event)) return;
    var message = parseYouTubeMessage(event.data);
    if (!message) return;

    if (message.event === 'onReady') {
      schedulePlayerSync(state);
      return;
    }

    if (!message.info) return;
    var playerState = typeof message.info.playerState === 'number' ? message.info.playerState : message.info;
    if (typeof playerState !== 'number') return;

    /* Only handle messages from the currently active iframe */
    var activeIframe = getIframe(state.slides[state.activeIndex]);
    if (!activeIframe || activeIframe.contentWindow !== event.source) return;

    /* Barra de progreso desde los mensajes de YouTube (infoDelivery) */
    if (typeof message.info.currentTime === 'number' && message.info.duration > 0) {
      setSlideProgress(state.slides[state.activeIndex], message.info.currentTime / message.info.duration);
    }

    if (playerState === 1) {
      /* Confirmed playing — sync controls to reality */
      if (!state.isPlaying) {
        state.isPlaying = true;
        updateVideoControls(state);
      }
    } else if (playerState === 0 || playerState === 2) {
      /* Confirmed paused/ended — sync controls to reality */
      if (state.isPlaying) {
        state.isPlaying = false;
        updateVideoControls(state);
      }
      /* If YouTube paused on its own (not user action), try to resume */
      if (!state.userPaused && playerState === 0) {
        schedulePlayerSync(state);
      }
    }
  }

  /* ── Slide activation ── */

  function activateSlide(state, index, behavior, shouldScroll) {
    if (index < 0 || index >= state.slides.length) return;

    var prevIndex = state.activeIndex;

    if (prevIndex !== index) {
      var prevSlide = state.slides[prevIndex];
      var prevVideo = getVideoEl(prevSlide);
      if (prevVideo) {
        prevVideo.pause();
      } else {
        var prevFrame = getFrame(prevSlide);
        if (prevFrame) unloadIframe(prevFrame, state.videos[prevIndex]);
      }
    }

    state.activeIndex = index;
    state.isPlaying   = false;   /* se confirma con el evento play (nativo) o playerState=1 (YT) */
    state.userPaused  = prefersReducedMotion();   /* fresh slide → we want to play (salvo reduced motion) */
    /* isMuted PERSISTE entre slides: si el usuario activó el sonido, la siguiente
       también arranca con audio (tras el gesto, el autoplay con sonido está permitido). */
    state.pendingSeek = true;
    setSlideProgress(state.slides[index], 0);

    /* Nativo: lo reproduce syncActivePlayer. YouTube: cargamos el iframe on-demand. */
    if (!getVideoEl(state.slides[index]) && !state.userPaused) {
      var activeFrame = getFrame(state.slides[index]);
      if (activeFrame && !getIframe(state.slides[index])) {
        var newIframe = loadIframe(activeFrame, state.videos[index], state.isMuted);
        newIframe.addEventListener('load', function () {
          sendYTInit(newIframe);
          schedulePlayerSync(state);
        });
      }
    }

    lockSlideInteractivity(state, index);
    updateVideoControls(state);
    schedulePlayerSync(state);

    state.dots.forEach(function (dot, i) {
      var active = i === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (shouldScroll !== false) {
      /* Bloquear el auto-sync de scroll un momento: cerca de los extremos el slide
         activo no se puede centrar (scroll topado), y sin esto el handler de scroll
         detectaría otro como "más cercano al centro" y rebotaría al anterior. */
      state.suppressSyncUntil = Date.now() + 550;
      state.slides[index].scrollIntoView({ behavior: behavior || 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  function findClosestSlideIndex(state) {
    var trackRect = state.track.getBoundingClientRect();
    var center    = trackRect.left + trackRect.width / 2;
    var closest   = 0;
    var minDist   = Infinity;
    state.slides.forEach(function (slide, index) {
      var rect    = slide.getBoundingClientRect();
      var cx      = rect.left + rect.width / 2;
      var dist    = Math.abs(center - cx);
      if (dist < minDist) { minDist = dist; closest = index; }
    });
    return closest;
  }

  /* ── Event binding ── */

  function bindEvents(state) {
    state.prevButton.addEventListener('click', function () {
      activateSlide(state, Math.max(state.activeIndex - 1, 0));
    });

    state.nextButton.addEventListener('click', function () {
      activateSlide(state, Math.min(state.activeIndex + 1, state.slides.length - 1));
    });

    state.dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { activateSlide(state, index); });
    });

    state.slides.forEach(function (slide, index) {
      slide.addEventListener('click', function (e) {
        if (index !== state.activeIndex) {
          activateSlide(state, index);
        } else if (e.target.closest && e.target.closest('.mld-reels-video-frame') &&
                   !e.target.closest('[data-mld-reels-audio-toggle]') &&
                   !e.target.closest('[data-mld-reels-play-toggle]')) {
          togglePlayPause(state);
        }
      });

      var playToggle = getPlayToggle(slide);
      if (playToggle) {
        playToggle.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (index !== state.activeIndex) { activateSlide(state, index); return; }
          togglePlayPause(state);
        });
      }

      var audioToggle = getAudioToggle(slide);
      if (audioToggle) {
        audioToggle.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          if (index !== state.activeIndex) { activateSlide(state, index); return; }
          toggleAudio(state);
        });
      }
    });

    /* Las slides inactivas son inert: el clic cae en el track. Buscamos cuál está
       bajo el puntero y la activamos (mismo comportamiento de antes). */
    state.track.addEventListener('click', function (e) {
      if (e.target !== state.track && !(e.target.closest && e.target.closest('[inert]'))) return;
      for (var i = 0; i < state.slides.length; i++) {
        var r = state.slides[i].getBoundingClientRect();
        if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
          if (i !== state.activeIndex) activateSlide(state, i);
          return;
        }
      }
    });

    var scrollTimer = null;
    state.track.addEventListener('scroll', function () {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        if (state.suppressSyncUntil && Date.now() < state.suppressSyncUntil) return;
        var newIndex = findClosestSlideIndex(state);
        if (newIndex !== state.activeIndex) activateSlide(state, newIndex, 'auto');
      }, 70);
    });

    state.messageHandler = function (event) { handlePlayerStateMessage(state, event); };
    window.addEventListener('message', state.messageHandler);

    document.addEventListener('visibilitychange', function () {
      var vEl = getVideoEl(state.slides[state.activeIndex]);
      if (vEl) {
        if (document.hidden) vEl.pause();
        else if (!state.userPaused) schedulePlayerSync(state);
        return;
      }
      var iframe = getIframe(state.slides[state.activeIndex]);
      if (!iframe) return;
      if (document.hidden) {
        sendYTCommand(iframe, 'pauseVideo');
        sendYTCommand(iframe, 'mute');
      } else if (!state.userPaused) {
        schedulePlayerSync(state);
      }
    });
  }

  /* ── Init ── */

  function initMoldarteReelsWidget(container, options) {
    var node = typeof container === 'string' ? document.querySelector(container) : container;
    if (!node || node[WIDGET_KEY]) return node && node[WIDGET_KEY];

    var config = Object.assign({}, parseConfigFromNode(node), options || {});
    var videos = Array.isArray(config.videos)
      ? config.videos.filter(function (v) { return v && (v.youtubeId || v.videoUrl); })
      : [];
    if (!videos.length) return null;

    var track         = node.querySelector('[data-mld-reels-track]');
    var dotsContainer = node.querySelector('[data-mld-reels-dots]');
    track.innerHTML         = '';
    dotsContainer.innerHTML = '';

    videos.forEach(function (video, index) {
      track.appendChild(createSlide(video, index));

      var dot = document.createElement('button');
      dot.type      = 'button';
      dot.className = 'mld-reels-dot';
      dot.setAttribute('aria-label', 'Ir al video ' + (index + 1));
      dotsContainer.appendChild(dot);
    });

    var state = {
      root:        node,
      videos:      videos,
      track:       track,
      slides:      Array.prototype.slice.call(track.querySelectorAll('.mld-reels-slide')),
      prevButton:  node.querySelector('[data-mld-reels-prev]'),
      nextButton:  node.querySelector('[data-mld-reels-next]'),
      dots:        Array.prototype.slice.call(dotsContainer.querySelectorAll('.mld-reels-dot')),
      isMuted:     true,
      isPlaying:   false,   /* confirmed by YouTube postMessage */
      userPaused:  false,   /* user's explicit pause intent */
      activeIndex: 0,
      pendingSeek: false,
      syncTimers:  [],
      audioTimers: []
    };

    node[WIDGET_KEY] = state;

    /* Sincronizar controles con la realidad de los <video> nativos */
    state.slides.forEach(function (slide, i) {
      var v = getVideoEl(slide);
      if (!v) return;
      v.addEventListener('play',  function () { if (i === state.activeIndex && !state.isPlaying) { state.isPlaying = true;  updateVideoControls(state); } });
      v.addEventListener('pause', function () { if (i === state.activeIndex &&  state.isPlaying) { state.isPlaying = false; updateVideoControls(state); } });
      v.addEventListener('timeupdate', function () {
        if (i === state.activeIndex && v.duration) setSlideProgress(slide, v.currentTime / v.duration);
      });
      /* Indicador de carga */
      v.addEventListener('waiting', function () { if (i === state.activeIndex) slide.classList.add('is-loading'); });
      v.addEventListener('playing', function () { slide.classList.remove('is-loading'); });
      v.addEventListener('canplay', function () { if (!v.paused) slide.classList.remove('is-loading'); });
    });

    updateVideoControls(state);
    bindEvents(state);
    activateSlide(state, 0, 'auto', false);

    return state;
  }

  window.initMoldarteReelsWidget = initMoldarteReelsWidget;
})();
